import { RefObject, useEffect } from "react";

export const useOutsideAlerter = (
    fn: () => void,
    ref: RefObject<HTMLElement | null>,
    ignoredClassList: string[] = []
) => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement | undefined;
            if (!target) {
                return;
            }

            if (
                ignoredClassList.find(
                    (value) => !!target.classList.contains(value)
                )
            ) {
                return;
            }

            if (
                target.parentElement &&
                ignoredClassList.find(
                    (value) => !!target.parentElement?.classList.contains(value)
                )
            ) {
                return;
            }

            if (
                ref.current &&
                !ref.current.contains(target) &&
                typeof fn === "function"
            ) {
                fn();
            }
        };

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
};
